<template>
  <div class="container">
    <div class="my-church-wrap-main clearfix">
      <div class="d-flex flex-wrap">
        <div class="col-12 col-sm-8 col-md-8">
          <div class="welcome">
            <h2>Welcome from {{churchProfile.name}}</h2>
            <i>We pray this a great resource for you and your family.</i><br />
          </div>
          <h2 class="church_profile_header">How to Use TrueLifeCare.org</h2>
          <div style="padding:52.66% 0 0 0;position:relative;">
            <iframe
              src="https://player.vimeo.com/video/285502033?title=0&amp;byline=0&amp;portrait=0"
              style="position:absolute;top:0;left:0;width:100%;height:100%;"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              frameborder="0"
            ></iframe>
          </div>
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div class="textwidget">
            <div class="button">
              <router-link :to="{ name: 'videoLibrary' }" v-text="'See Video Library'" />
            </div>
            <br />
           
            
            <template v-if="!isEmpty(churchProfile)">
              <h2>Contact Information</h2>
              <p>If you would like to connect, or to find additional help please use the contact information below.</p>
              <p v-html="`<strong>Pastor:</strong> ${churchProfile.care_pastor}`"></p>
              <p v-html="`<strong>Website:</strong> ${churchProfile.care_website}`"></p>
              <p v-html="`<strong>Email:</strong> ${churchProfile.care_email}`"></p>
              <p v-html="`<strong>Phone:</strong> ${churchProfile.care_phone}`"></p>
              <p v-html="`<strong>Address:</strong> ${churchProfile.care_address}`"></p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty, find } from 'lodash'
import { mapState } from 'vuex'
import UserService from '@/services/UserService'
export default {
  name: 'MyChurchProfile',
  data: () => ({
    churchProfile: {}
  }),
  async mounted() {
    this.churchProfile = await this.$store.dispatch('getChurchProfile')
  },
  methods: {
    isEmpty
  }
}
</script>
<style lang="scss">
.my-church-wrap-main {
  padding: 40px 0;
  color: #787d85;
  font-weight: 300;
  .welcome {
    margin-bottom: 5px;
    h2 {
      margin: 0;
      line-height: 25px;
    }
    i {
      font-size: 13px;
      line-height: 14px;
    }
  }
  .button {
    margin-bottom: 30px;
    a {
      color: #fff;
      font-size: 18px;
      line-height: 45px;
      font-weight: 500;
      padding: 14px 20px;
      border-radius: 25px;
      background-color: #6ab165;
    }
  }
  h2 {
    font-size: 25px;
    font-family: 'Open Sans';
    font-weight: 300;
    line-height: 35px;
    text-transform: uppercase;
  }
  p {
    font-size: 14px;
    line-height: 26px;
  }
  @media (max-width: 575.98px) {
    .col-12 {
      padding: 0;
      border: none;
      &:nth-child(2) {
        margin-top: 60px;
      }
    }
  }
}
</style>
